<template>
  <div v-show="active" :id="id" class="tab-panel" :class="{ active: active }">
    <slot />
  </div>
</template>

<script>
import TooltipMixin from "../../mixins/TooltipMixin"

export default {
  name: "TabItem",
  mixins: [TooltipMixin],
  inject: ["parentTab"],
  props: {
    /** Título da aba */
    title: {
      type: String,
      default: "Sobre",
    },
    /** Identificador da aba */
    id: {
      type: String,
      default: "",
    },
    /** Ícone que é mostrado na aba */
    icon: {
      type: String,
      default: "",
    },
    /**
     * **[OPCIONAL]** Define o valor do contador.
     * */
    results: {
      type: String,
      default: "",
    },
    /**
     * **[OPCIONAL]** Define se a aba está ativa/aberta.
     * */
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: this.isActive,
    }
  },
  mounted() {
    this.parentTab.addTabItem(this)
  },
  methods: {
    setActive(active) {
      this.active = active
    },
  },
}
</script>

<style lang="scss">
@import "~@govbr-ds/core/src/partial/scss/_base";
@import "~@govbr-ds/core/src/components/tab/_tab";

.tab-panel {
  color: var(--text-color);
}
</style>
